import { useCallback, useEffect, useState } from "react";
import Emotii from "./components/Slides/Emotii";
import SlideWrapper from "./components/SlideWrapper";
import Result from "./components/Result";
import InstructionSlide from "./components/Slides/InstructionSlide";
import TermsSlide from "./components/Slides/TermsSlide";
import PromptSlide from "./components/Slides/PromptSlide";
import NoteSlide from "./components/Slides/NoteSlide";
import DifficultySlide from "./components/Slides/DifficultySlide";
import GettingStarted from "./components/Slides/GettingStarted";
import { useAuth0 } from "@auth0/auth0-react";
import Home from "./components/pages/Home";
import { useDispatch, useSelector } from "react-redux";
import {
  incrementCurrentSlide,
  incrementPeekSlide,
} from "./store/slices/slides";
import { submitAssessment } from "./store/slices/assessment";
import useAuditLogin from "./hooks/useAuditLogin";
import usePersistAssessment from "./hooks/usePersistAssessment";
import PopupsHandler from "./components/popups/PopupsHandler";
import useAnonymousUserAssesment from "./hooks/useAnonymousUserAssesment";
import MyAccount from "./components/Slides/MyAccount";

function App() {
  const dispatch = useDispatch();

  const { data: assessment } = useSelector((state) => state.assessment);
  const { user, isAuthenticated } = useAuth0();

  const { footerComponent, popupComponent } = useSelector((state) => state.ui);

  const [hasRegisteredLogin, setHasRegisteredLogin] = useState();

  usePersistAssessment();
  useAuditLogin(hasRegisteredLogin, setHasRegisteredLogin);
  useAnonymousUserAssesment();

  const onSubmit = async () => {
    try {
      await dispatch(submitAssessment({ user }));
      dispatch(incrementCurrentSlide());
      dispatch(incrementPeekSlide());
    } catch (error) {}
  };

  const skipGettingStarted =
    isAuthenticated &&
    assessment?.patient?.firstName &&
    assessment?.patient?.lastName &&
    assessment?.patient?.dob;

  return (
    <>
      <SlideWrapper>
        <Home />
        <GettingStarted isDisabled={skipGettingStarted} />
        <TermsSlide />
        <InstructionSlide />

        <Emotii
          id="stress"
          title="Stress"
          leftTitle="stressed"
          rightTitle="stressed"
          leftTitlePrefix="not"
          rightTitlePrefix="extremely"
          quickTipMessage=""
          imageGifUrl={
            "https://demo-healthconnexx-app.s3.amazonaws.com/assets/images/gifs/stress.gif"
          }
        />

        <Emotii
          id="anxiety"
          title="Anxiety"
          leftTitle="anxious"
          rightTitle="anxious"
          leftTitlePrefix="not"
          rightTitlePrefix="extremely"
          quickTipMessage=""
          imageGifUrl={
            "https://demo-healthconnexx-app.s3.amazonaws.com/assets/images/gifs/anxiety.gif"
          }
        />
        <Emotii
          id="illness"
          title="Illness"
          leftTitle="sick"
          rightTitle="healthy"
          leftTitlePrefix="extremely"
          rightTitlePrefix="extremely"
          reverse
          quickTipMessage=""
          imageGifUrl={
            "https://demo-healthconnexx-app.s3.amazonaws.com/assets/images/gifs/bipolar-wellness.gif"
          }
        />
        <Emotii
          id="irritability"
          title="Irritability"
          leftTitle="irritable"
          rightTitle="irritable"
          leftTitlePrefix="not"
          rightTitlePrefix="extremely"
          quickTipMessage=""
          imageGifUrl={
            "https://demo-healthconnexx-app.s3.amazonaws.com/assets/images/gifs/irritability.gif"
          }
        />
        <Emotii
          id="loneliness"
          title="Loneliness"
          leftTitle="lonely"
          rightTitle="lonely"
          leftTitlePrefix="not"
          rightTitlePrefix="extremely"
          quickTipMessage=""
          imageGifUrl={
            "https://demo-healthconnexx-app.s3.amazonaws.com/assets/images/gifs/loneliness.gif"
          }
        />

        <Emotii
          id="depression"
          title="Depression"
          leftTitle="depressed"
          rightTitle="depressed"
          leftTitlePrefix="not"
          rightTitlePrefix="extremely"
          quickTipMessage=""
          imageGifUrl={
            "https://demo-healthconnexx-app.s3.amazonaws.com/assets/images/gifs/depression.gif"
          }
        />

        <Emotii
          id="pain"
          title="Pain"
          leftTitle="pain"
          rightTitle="pain"
          leftTitlePrefix="no"
          rightTitlePrefix="extreme"
          quickTipMessage=""
          imageGifUrl={
            "https://demo-healthconnexx-app.s3.amazonaws.com/assets/images/gifs/pain.gif"
          }
        />
        <Emotii
          id="fatigue"
          title="Fatigue"
          leftTitle="run-down"
          rightTitle="energetic"
          leftTitlePrefix="very"
          rightTitlePrefix="very"
          quickTipMessage=""
          reverse
          imageGifUrl={
            "https://demo-healthconnexx-app.s3.amazonaws.com/assets/images/gifs/fatigue2.gif"
          }
        />
        <Emotii
          id="difficulty"
          title="Managing Life"
          leftTitle="difficult"
          rightTitle="difficult"
          subtitle="including home, work, relationships & health"
          leftTitlePrefix="not"
          rightTitlePrefix="extremely"
          quickTipMessage=""
          imageGifUrl={
            "https://demo-healthconnexx-app.s3.amazonaws.com/assets/images/gifs/difficulty.gif"
          }
        />

        <NoteSlide onSubmit={onSubmit} />
        <Result />
        <MyAccount />
      </SlideWrapper>

      <footer className="footer">{footerComponent}</footer>
      <PopupsHandler />
    </>
  );
}

export default App;
